var _style, _radialGradient, _radialGradient2, _radialGradient3, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _circle, _path, _path2, _rect, _path3, _path4, _path5, _path6, _rect2, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGraphicHeartsVerified = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "2in",
    width: "3in",
    viewBox: "0 0 216 144",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes beat{0%,60%,90%,to{transform:scale(1)}25%{transform:scale(.8)}80%{transform:scale(.9)}}.heart{animation:beat 1.5s infinite}")), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 133.87,
    cy: 114.93,
    gradientUnits: "userSpaceOnUse",
    r: 128.97
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#cdcdd4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#cdcdd4",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#cdcdd4",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#cdcdd4",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdcdd4",
    stopOpacity: 0.2
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 89.36,
    cy: 94.91,
    gradientUnits: "userSpaceOnUse",
    r: 102.61
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#cdcdd4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#cdcdd4",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#cdcdd4",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#cdcdd4",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#cdcdd4",
    stopOpacity: 0.2
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 75.77,
    cy: 203.9,
    gradientUnits: "userSpaceOnUse",
    r: 150.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#cdcdd4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#cdcdd4",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#cdcdd4",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#cdcdd4",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#cdcdd4",
    stopOpacity: 0.2
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 105.4,
    x2: 182.03,
    y1: 76.22,
    y2: -0.41
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#00b3f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#00bbf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00d2fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0df"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 49.63,
    x2: 109.11,
    y1: 105.11,
    y2: 45.64
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c689ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d74cf0"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 19.43,
    x2: 120.37,
    y1: 141.35,
    y2: 40.41
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#b833e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#ff4f5e"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 62.25,
    x2: 181.48,
    y1: 169.32,
    y2: 50.09
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#7542e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#824deb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#a067fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab71ff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 106.58,
    cy: 72,
    fill: "url(#a)",
    r: 67.79
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.68 36.27a9.51 9.51 0 01-9.47 9.51H27.14a7.27 7.27 0 010-14.54 7.15 7.15 0 011.74.22 7.82 7.82 0 01-.2-1.69 7.5 7.5 0 017.51-7.49 7.42 7.42 0 014.23 1.32 12.6 12.6 0 0124.79 3.16 9.51 9.51 0 019.47 9.51z",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.59 105.85a10.8 10.8 0 00-2.62.32 11.09 11.09 0 00.29-2.53 11.31 11.31 0 00-17.69-9.32 19 19 0 00-37.36 4.78 14.27 14.27 0 100 28.54h57.38a10.9 10.9 0 100-21.79z",
    fill: "url(#c)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#d)",
    height: 61.41,
    rx: 5.4,
    width: 75.77,
    x: 106.31,
    y: 6.71
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.01 32.2H177v9.99h-4.99z",
    fill: "#0df"
  })), /*#__PURE__*/React.createElement("path", {
    className: "heart",
    d: "M149.54 30.15a6.26 6.26 0 00-8.85 0l-1.26 1.26-1.26-1.26a6.26 6.26 0 00-8.85 8.85l9 9a1.51 1.51 0 001.08.45 1.53 1.53 0 001.08-.45l9-9a6.26 6.26 0 00.06-8.85z",
    fill: "#f9f9fa",
    style: {
      transformOrigin: "65% 25%"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.08 101.22h29.85v8.65H66.08z",
    fill: "#ff848b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.55 51.72h71.63v47.31H43.55z",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123 103.81h-2V50.05a3.86 3.86 0 00-3.86-3.86H41.65a3.86 3.86 0 00-3.86 3.86v53.76h-1.95a1.92 1.92 0 00-1.93 1.92v3.9a1.92 1.92 0 001.93 1.93H123a1.93 1.93 0 001.93-1.93v-3.9a1.93 1.93 0 00-1.93-1.92zm-35.82 3.87H71.66v-3.87h15.49z",
    fill: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "heart",
    d: "M89.52 67.33a6.28 6.28 0 00-8.85 0l-1.27 1.26-1.26-1.26a6.26 6.26 0 00-8.85 0 6.26 6.26 0 000 8.85l9 9a1.51 1.51 0 002.15 0l9-9a6.26 6.26 0 00.08-8.85z",
    fill: "#f9f9fa",
    style: {
      transformOrigin: "37% 52%"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#g)",
    height: 62.76,
    rx: 5.4,
    width: 41.61,
    x: 104.85,
    y: 74.54
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.72 127.06h7.75v3.87h-7.75z",
    fill: "#ab71ff"
  })), /*#__PURE__*/React.createElement("path", {
    className: "heart",
    d: "M135.7 93.67a6.28 6.28 0 00-8.85 0l-1.26 1.27-1.26-1.26a6.26 6.26 0 00-8.85 8.85l9 9a1.53 1.53 0 001.08.45 1.51 1.51 0 001.08-.45l9-9a6.26 6.26 0 00.06-8.86z",
    fill: "#f9f9fa",
    style: {
      transformOrigin: "58% 69%"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGraphicHeartsVerified);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graphic_hearts_verified.93db23fbb71a82ca1c27fde66af75bb8.svg";